/** Upper bound per step (session, then PSI calls), so a hung request never holds back the page view. */
export const SESSION_REQUEST_TIMEOUT_MS = 5000;

export const SESSION_JWT_STATUS = {
  LOADING: 'loading',
  READY: 'ready',
} as const;
